var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadDisabled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "rgba(0, 0, 0, 0.26)",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58333 16.6667C4.25 16.6667 3.95833 16.5417 3.70833 16.2917C3.45833 16.0417 3.33333 15.75 3.33333 15.4167V12.4375H4.58333V15.4167H15.4167V12.4375H16.6667V15.4167C16.6667 15.75 16.5417 16.0417 16.2917 16.2917C16.0417 16.5417 15.75 16.6667 15.4167 16.6667H4.58333ZM10 13.4792L5.97917 9.45834L6.875 8.5625L9.375 11.0625V3.33334H10.625V11.0625L13.125 8.5625L14.0208 9.45834L10 13.4792Z",
    fill: "rgba(0, 0, 0, 0.26)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadDisabled);
export default __webpack_public_path__ + "static/media/Download_disabled.541a8b7cedbd5bcf8b87838e2d2e24a3.svg";
export { ForwardRef as ReactComponent };